export const en: Record<string, string> = {

  'Dashboard': 'Dashboard',
  'Profile': 'Profile',
  'Personal Details': 'Personal Details',
  'Demographics': 'Demographics',
  'Medical History': 'Medical History',
  'Insurance Information': 'Insurance Information',
  'Documents': 'Documents',
  'Settings': 'Settings',
  'Manage your basic details, contact information, and emergency contacts using the sections below.': 'Manage your basic details, contact information, and emergency contacts using the sections below.',
  'Profile Photo': 'Profile Photo',
  'Basic Details': 'Basic Details',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Date of Birth': 'Date of Birth',
  'Address': 'Address',
  'City': 'City',
  'State': 'State',
  'ZIP Code': 'ZIP Code',
  'Country': 'Country',
  'Care Team': 'Care Team',
  'Internal Co-manager': 'Internal Co-manager',
  'External Co-manager': 'External Co-manager',
  'Primary Care Physician': 'Primary Care Physician',
  'Referral': 'Referral',
  'Contact Information': 'Contact Information',
  'Email': 'Email',
  'Mobile Number': 'Mobile Number',
  'Emergency Contact Information': 'Emergency Contact Information',
  'Name': 'Name',
  'Relation': 'Relation',
  'Communication Preference': 'Communication Preference',
  'SMS': 'SMS',
  'Demographics & Personal Background': 'Demographics & Personal Background',
  'Review and update your personal information, language preferences, and identity details to help us provide better care.': 'Review and update your personal information, language preferences, and identity details to help us provide better care.',
  'Details': 'Details',
  'Ethnicity': 'Ethnicity',
  'Race': 'Race',
  'Preferred Language': 'Preferred Language',
  'Expressions': 'Expressions',
  'Proficiency': 'Proficiency',
  'Sexual Orientation': 'Sexual Orientation',
  'Gender Identity': 'Gender Identity',
  'Multiple Births': 'Multiple Births',
  'Review your medical history summary here, and click the Edit button to update any details.': 'Review your medical history summary here, and click the Edit button to update any details.',
  'Medical Conditions': 'Medical Conditions',
  'Lifestyle Factors': 'Lifestyle Factors',
  'Alcohol Consumption': 'Alcohol Consumption',
  'Smoking': 'Smoking',
  'Drugs Use': 'Drugs Use',
  'Current Medications': 'Current Medications',
  'Allergies': 'Allergies',
  'Is there anything else we should know?': 'Is there anything else we should know?',
  'Monitor for any signs of allergic reaction, and administer antihistamines as needed.': 'Monitor for any signs of allergic reaction, and administer antihistamines as needed.',
  'Review and manage your insurance coverage details': 'Review and manage your insurance coverage details',
  'Coverage Type': 'Coverage Type',
  'Payor': 'Payor',
  'Plan': 'Plan',
  'Policy Holder': 'Policy Holder',
  'Policy ID': 'Policy ID',
  'Group ID': 'Group ID',
  'Effective Date': 'Effective Date',
  'Expiry Date': 'Expiry Date',
  'Insurance Card Images': 'Insurance Card Images',
  'Files & Records': 'Files & Records',
  'Download, review, or update your documents.': 'Download, review, or update your documents.',
  'Action': 'Action',
  'No documents found': 'No documents found',
  'Download': 'Download',
  'Delete': 'Delete',
  'Account & Preferences': 'Account & Preferences',
  'Manage your account details, security settings, and communication preferences.': 'Manage your account details, security settings, and communication preferences.',
  'Account': 'Account',
  'Change Password': 'Change Password',
  'Login Activity': 'Login Activity',
  'Preferences': 'Preferences',
  'Language': 'Language',
  'Current Password': 'Current Password',
  'Enter current password': 'Enter current password',
  'Current password is required.': 'Current password is required.',
  'Password must be at least 8 characters.': 'Password must be at least 8 characters.',
  'New Password': 'New Password',
  'Enter new password': 'Enter new password',
  'New password is required.': 'New password is required.',
  'Confirm New Password': 'Confirm New Password',
  'Re-enter new password': 'Re-enter new password',
  'Please confirm your new password.': 'Please confirm your new password.',
  'Passwords do not match.': 'Passwords do not match.',
  'Cancel': 'Cancel',
  'Save Changes': 'Save Changes',
  'Current': 'Current',
  'Sign Out': 'Sign Out',
  'Sign Out of Other Devices': 'Sign Out of Other Devices',
  'Unsaved Changes': 'Unsaved Changes',
  'You have unsaved changes. If you switch tabs, your edits won\'t be saved. Do you still want to proceed?': 'You have unsaved changes. If you switch tabs, your edits won\'t be saved. Do you still want to proceed?',
  'No': 'No',
  'Yes': 'Yes',



  //Prescriptions
  'Prescriptions': 'Prescriptions',
  'View your active medications and download your prescriptions.': 'View your active medications and download your prescriptions.',
  'Prescription List': 'Prescription List',
  'Download Prescription': 'Download Prescription',
  'Medications Prescribed': 'Medications Prescribed',
  'Duration:': 'Duration:',
  'Quantity': 'Quantity',
  'Days Supply': 'Days Supply',
  'Refills Left': 'Refills Left',
  'Prescribed By': 'Prescribed By',
  'Medication Instructions': 'Medication Instructions',
  'No Prescriptions prescribed': 'No Prescriptions prescribed',
  'View Details': 'View Details',
  'Request medication refill?': 'Request medication refill?',
  'This request will be sent to your care team for review. You\'ll be notified once it\'s processed.': 'This request will be sent to your care team for review. You\'ll be notified once it\'s processed.',
  'Your request has been sent!': 'Your request has been sent!',
  'Need Help?': 'Need Help?',
  'We are here to assist you': 'We are here to assist you',
  'Our support team is available': 'Our support team is available',
  'Monday - Friday, 8:00 AM': 'Monday - Friday, 8:00 AM',
  'to': 'to',
  '6:00 PM': '6:00 PM',
  'EST. Call or text us for assistance with your profile, appointments, or any questions.': 'EST. Call or text us for assistance with your profile, appointments, or any questions.',
  'Call': 'Call',


















  'My Visits': 'My Visits',
  'Forms': 'Forms',
  'Activity Logs': 'Activity Logs',
  'Education Library': 'Education Library',
  'Logout Account': 'Logout Account',

  // ── Desktop Header ──
  'Clinic Support:': 'Clinic Support:',



















  'My Onboarding Forms': 'My Onboarding Forms',
  'Start a new form or continue with your pending ones.': 'Start a new form or continue with your pending ones.',

  // ── Table Headers ──
  'S.No': 'S.No',
  'Doctor Name': 'Doctor Name',
  'Appointment Date & Time': 'Appointment Date & Time',
  'Status': 'Status',
  'Actions': 'Actions',

  // ── Section Headings ──
  'Upcoming Appointments': 'Upcoming Appointments',
  'Previous Appointments': 'Previous Appointments',

  // ── Status Labels ──
  'New': 'New',
  'Pending': 'Pending',
  'Submitted': 'Submitted',
  'Reviewed': 'Reviewed',

  // ── Action Buttons ──
  'Start Onboarding Form': 'Start Onboarding Form',
  'Continue Filling Form': 'Continue Filling Form',
  'View/Edit Form': 'View/Edit Form',
  'View Form': 'View Form',

  // ── Empty State ──
  'No Upcoming Appointments': 'No Upcoming Appointments',
  'You have no scheduled or appointments.': 'You have no scheduled or appointments.',

  // ── Onboarding Offcanvas ──
  'Onboarding Summary': 'Onboarding Summary',
  'Review your details. Click \'Edit the form\' to update the information.': 'Review your details. Click \'Edit the form\' to update the information.',
  'Edit the form': 'Edit the form',
























  'Education Video Library': 'Education Video Library',
  'Learn about your eye health and upcoming procedures.': 'Learn about your eye health and upcoming procedures.',

  'Ordered By': 'Ordered By',
  'Sent On': 'Sent On',
  'Procedure': 'Procedure',

  // ── Education Library Actions ──
  'Watch': 'Watch',
  'View Image': 'View Image',
  'View PDF': 'View PDF',
  'Play Video': 'Play Video',
  'Open Document': 'Open Document',

  // ── Education Library Empty State ──
  'No documents available': 'No documents available',

  // ── Dashboard Header ──
  'Welcome': 'Welcome',
  'Documents shared by your care team': 'Documents shared by your care team',
  'Manage your visits, bills, and health information in one place.': 'Manage your visits, bills, and health information in one place.',

  // ── Dashboard Quick Actions (Mobile) ──
  'Book Appt': 'Book Appt',
  'Bill Pay': 'Bill Pay',
  'Insurance': 'Insurance',

  // ── Dashboard Quick Actions (Desktop) ──
  'Book Appointment': 'Book Appointment',

  'View All Forms': 'View All Forms',
  'at': 'at',
  'Reschedule Requested': 'Reschedule Requested',
  'Rescheduled': 'Rescheduled',
  'Completed': 'Completed',
  'Cancelled': 'Cancelled',
  'Fill Onboarding Form': 'Fill Onboarding Form',
  'Continue Filling Onboarding form': 'Continue Filling Onboarding form',

  // ── Dashboard Carousel Slides ──
  'Buy One, Get One on Contact Lenses': 'Buy One, Get One on Contact Lenses',
  'Stock up and save on your vision needs.': 'Stock up and save on your vision needs.',
  '20% Off Eyeglasses': '20% Off Eyeglasses',
  'Trendy frames for every face.': 'Trendy frames for every face.',
  'Free Eye Checkup': 'Free Eye Checkup',
  'Limited time offer with purchases.': 'Limited time offer with purchases.',

  // ── Dashboard Billing ──
  'Billing Status': 'Billing Status',
  'Outstanding Balance': 'Outstanding Balance',
  'Pay Now': 'Pay Now',
  'View Statement': 'View Statement',
  'Billing not started yet': 'Billing not started yet',
  'No outstanding balance. Your account is in good standing.': 'No outstanding balance. Your account is in good standing.',

  // ── Dashboard Vision ──
  'Vision Summary': 'Vision Summary',
  'Last Vision Values': 'Last Vision Values',
  'Right Eye': 'Right Eye',
  'Left Eye': 'Left Eye',
  'Glass Prescription': 'Glass Prescription',
  'SPH': 'SPH',
  'CYL': 'CYL',
  'AXIS': 'AXIS',
  'No vision data on file': 'No vision data on file',
  'Complete your first eye exam to see your vision summary here.': 'Complete your first eye exam to see your vision summary here.',

  // ── Dashboard Reminders ──
  'Reminders & Alerts': 'Reminders & Alerts',
  'Remind me': 'Remind me',
  'No Alerts!': 'No Alerts!',

  // ── Dashboard Recent Visits ──
  'Recent Visits': 'Recent Visits',
  'View All Visits': 'View All Visits',
  'No visit history yet': 'No visit history yet',
  'Your past appointments and visit records will appear here.': 'Your past appointments and visit records will appear here.',
  'No Show': 'No Show',

  'Book an appointment with your optometrist to get started.': 'Book an appointment with your optometrist to get started.',

  'View Library': 'View Library',
  'Patient has no insurances': 'Patient has no insurances',
  'Support Phone Number': 'Support Phone Number',

  // ── Reschedule Popovers ──
  'Reschedule Remarks': 'Reschedule Remarks',
  'Reschedule Details': 'Reschedule Details',
  'New Appointment': 'New Appointment',
  'This appointment is rescheduled to': 'This appointment is rescheduled to',
  'Reason:': 'Reason:',

  // ── Card Payment Modal ──
  'Card Payment': 'Card Payment',

  'A record of what you viewed, downloaded, or changed': 'A record of what you viewed, downloaded, or changed',
  'Filter': 'Filter',

  // ── Activity Logs Filter Form ──
  'From Date': 'From Date',
  'To Date': 'To Date',
  'Log Type': 'Log Type',
  'Search': 'Search',
  'Select All': 'Select All',

  'Date': 'Date',
  'Time': 'Time',
  'Description': 'Description',

  // ── Activity Log Type Badges ──
  'Accessed': 'Accessed',
  'Exported': 'Exported',
  'Transmitted': 'Transmitted',
  'Downloaded': 'Downloaded',
  'Added': 'Added',
  'Deleted': 'Deleted',
  'Edited': 'Edited',
  'Login': 'Login',
  'Logout': 'Logout',

  // ── Activity Logs Pagination ──
  'Back': 'Back',
  'Next': 'Next',

  // ── Activity Logs Mobile Filter ──
  'Date Range': 'Date Range',
  'From': 'From',
  'To': 'To',
  'Reset': 'Reset',
  'Apply Filters': 'Apply Filters',

























  'Review your health summaries, download official case sheets, and share them anytime.':
    'Review your health summaries, download official case sheets, and share them anytime.',
  'Download Visit Summary': 'Download Visit Summary',

  // Appointment Sections
  'Current Appointments': 'Current Appointments',

  // Appointment Details
  'Provider': 'Provider',
  'Surgery': 'Surgery',
  'Location': 'Location',

  // Status Labels
  'Confirmed': 'Confirmed',
  'Not Confirmed': 'Not Confirmed',
  'Active': 'Active',
  'InActive': 'InActive',

  // Dropdown Actions
  'View visit summary': 'View visit summary',
  'Export visit summary': 'Export visit summary',
  'View summary': 'View summary',
  'View technical data (CCDA format)': 'View technical data (CCDA format)',
  'Share via email': 'Share via email',
  'Send Reschedule Request': 'Send Reschedule Request',
  'FG Rx Print': 'FG Rx Print',

  // No Data
  'No Appointments Found': 'No Appointments Found',
  'You have no scheduled or past appointments.': 'You have no scheduled or past appointments.',

  // Mobile View
  'Show details': 'Show details',

  // Download Visit Summary Popup
  'Download Visit Summary Title': 'Download Visit Summary',
  'Provider Name': 'Provider Name',
  'Appt. Date': 'Appt. Date',
  'Visit Reason': 'Visit Reason',
  'Last Exported By': 'Last Exported By',
  'Last Export Date': 'Last Export Date',
  'No Data Found': 'No Data Found',

  // Consultation Summary Popup
  'Consultation Summary': 'Consultation Summary',
  'Download Button': 'Download',
  'Chief Complaints': 'Chief Complaints',
  'Review of Systems': 'Review of Systems',
  'Ocular History': 'Ocular History',
  'Ocular Surgical History': 'Ocular Surgical History',
  'Current Eye Medication': 'Current Eye Medication',
  'Past Medical History': 'Past Medical History',
  'Surgical History': 'Surgical History',
  'Current Systemic Medication': 'Current Systemic Medication',
  'Family History': 'Family History',
  'Functional Status': 'Functional Status',
  'Menstrual History': 'Menstrual History',
  'Vaccination History': 'Vaccination History',
  'Birth History': 'Birth History',
  'Nutritional History': 'Nutritional History',
  'Physical Evaluation': 'Physical Evaluation',
  'Implants': 'Implants',
  'Psychological Observations': 'Psychological Observations',
  'Lifestyle History': 'Lifestyle History',
  'Psychiatry': 'Psychiatry',
  'Health Concerns & Goals': 'Health Concerns & Goals',
  'Lab & Investigation': 'Lab & Investigation',
  'Vitals': 'Vitals',
  'Fall Risk Assessment': 'Fall Risk Assessment',

  // Table Headers - Review of Systems
  'Medical Condition': 'Medical Condition',
  'Sub Relation': 'Sub Relation',
  'Age': 'Age',
  'Concern Expressed by': 'Concern Expressed by',
  'Goals Expressed by': 'Goals Expressed by',
  'Onset': 'Onset',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Result Value': 'Result Value',
  'Medicine & ROA': 'Medicine & ROA',
  'Refills': 'Refills',
  'Vaccine & Manufacturer': 'Vaccine & Manufacturer',
  'Dosage': 'Dosage',
  'Habit': 'Habit',
  'Consumption': 'Consumption',
  'Assessment Criteria': 'Assessment Criteria',
  'Response': 'Response',
  'Score': 'Score',

  // Vitals
  'Temperature': 'Temperature',
  'Pulse': 'Pulse',
  'BP-Systolic': 'BP-Systolic',
  'BP-Diastolic': 'BP-Diastolic',
  'Resp. Rate': 'Resp. Rate',
  'SpO2': 'SpO2',
  'Inh. O2 Conc.': 'Inh. O2 Conc.',
  'BGL': 'BGL',
  'HOFC Perc.': 'HOFC Perc.',
  'Weight': 'Weight',
  'Height': 'Height',
  'BMI': 'BMI',
  'Heart Rate': 'Heart Rate',

  // Dilation
  'Dilation': 'Dilation',
  'Eye': 'Eye',
  'Drops': 'Drops',
  'Frequency': 'Frequency',
  'Start Time': 'Start Time',
  'Notes': 'Notes',
  'No, Dilation has not been performed for this visit':
    'No, Dilation has not been performed for this visit',

  // Vision and Perception
  'Vision and Perception': 'Vision and Perception',
  'Visual Acuity': 'Visual Acuity',
  'Auto Refraction': 'Auto Refraction',
  'Retinoscopy': 'Retinoscopy',
  'Present Glass Rx': 'Present Glass Rx',
  'Manifest Refraction': 'Manifest Refraction',
  'Final Glass Rx': 'Final Glass Rx',
  'Cycloplegic Refraction': 'Cycloplegic Refraction',
  'Over Refraction': 'Over Refraction',
  'Pachymetry': 'Pachymetry',
  'IOP (Tonometry)': 'IOP (Tonometry)',
  'Pupil Size': 'Pupil Size',
  'PAM (Potential Acuity Meter)': 'PAM (Potential Acuity Meter)',
  'Keretometry': 'Keretometry',
  'Glare': 'Glare',

  // Vision Table Headers
  'SC-(D)': 'SC-(D)',
  'SC-(N)': 'SC-(N)',
  'CC-(GL)(D)': 'CC-(GL)(D)',
  'CC-(GL)(N)': 'CC-(GL)(N)',
  'CC-(CL)(D)': 'CC-(CL)(D)',
  'CC-(CL)(N)': 'CC-(CL)(N)',
  'Pinhole(D)': 'Pinhole(D)',
  'TAC(D)': 'TAC(D)',
  'Sph': 'Sph',
  'Cyl': 'Cyl',
  'Axis': 'Axis',
  'Add': 'Add',
  'Prism': 'Prism',
  'Type': 'Type',
  'Duo': 'Duo',
  'Cs': 'Cs',
  'VA (D)': 'VA (D)',
  'VA (N)': 'VA (N)',
  'VA (I)': 'VA (I)',

  // Pachymetry Table
  'H Axis': 'H Axis',
  'V Axis': 'V Axis',
  'Avg. K Value': 'Avg. K Value',
  'Cyl Value': 'Cyl Value',
  'Average': 'Average',
  'Given by': 'Given by',
  'Device': 'Device',
  'OD CC': 'OD CC',
  'OS CC': 'OS CC',

  // Contact Lens
  'Contact Lens - Soft Contact Lens': 'Contact Lens - Soft Contact Lens',
  'RGP ( Rigid Gas Permeable )': 'RGP ( Rigid Gas Permeable )',
  'Wearing': 'Wearing',
  'Trail': 'Trail',
  'Final': 'Final',
  'Dispensed Trial': 'Dispensed Trial',
  'Manufacturer': 'Manufacturer',
  'Series': 'Series',
  'BC': 'BC',
  'Diameter': 'Diameter',
  'Colour': 'Colour',
  'Rx Expiration': 'Rx Expiration',
  'Replacement Schedule': 'Replacement Schedule',
  'Wearing Instruction': 'Wearing Instruction',
  'Advance': 'Advance',
  'Fit': 'Fit',
  'Comfort': 'Comfort',
  'Centration': 'Centration',
  'Coverage': 'Coverage',
  'Movement': 'Movement',
  'Degree': 'Degree',
  'Direction': 'Direction',
  'Added by': 'Added by',

  // Examination
  'Examination': 'Examination',
  'Anterior Segment': 'Anterior Segment',
  'Posterior Segment': 'Posterior Segment',
  'Gonioscopy': 'Gonioscopy',
  'Motor Examinations': 'Motor Examinations',
  'Extra Ocular Motility': 'Extra Ocular Motility',
  'Ductions': 'Ductions',
  '9 Gaze Evaluation': '9 Gaze Evaluation',
  'Squint Evaluation': 'Squint Evaluation',
  'Cover/Alternate Cover Test': 'Cover/Alternate Cover Test',
  'Corneal Reflex / HCRT': 'Corneal Reflex / HCRT',
  'Prism Cover / Alternate Cover Test': 'Prism Cover / Alternate Cover Test',
  'Nystagmus': 'Nystagmus',
  'Head Posture': 'Head Posture',
  'Binocular Vision Test': 'Binocular Vision Test',
  'Worth Four Dot Test': 'Worth Four Dot Test',
  'Near Point Convergence': 'Near Point Convergence',
  'Fusional Vergence': 'Fusional Vergence',
  'Near Point Accomodation': 'Near Point Accomodation',
  'Stereopsis': 'Stereopsis',
  'Additional Examinations': 'Additional Examinations',
  'Dry Eye Evaluation': 'Dry Eye Evaluation',
  'Color Vision Test': 'Color Vision Test',
  'Lacrimal Patency': 'Lacrimal Patency',
  'Amsler Grid': 'Amsler Grid',
  '4 Field Test': '4 Field Test',
  '8 Field Test': '8 Field Test',

  // Assessments
  'Assessments': 'Assessments',
  'Site': 'Site',
  'Priority': 'Priority',
  'Severity & Status': 'Severity & Status',
  'Plan Of Discussions': 'Plan Of Discussions',
  'Patient Instructions': 'Patient Instructions',
  'Doctor Notes': 'Doctor Notes',
  'Other Actions Taken': 'Other Actions Taken',
  'Investigations': 'Investigations',

  // Orders
  'Orders': 'Orders',
  'Investigation': 'Investigation',
  'Procedure Details': 'Procedure Details',
  'Surgery Details': 'Surgery Details',
  'Cost Estimated': 'Cost Estimated',
  'Patient Education': 'Patient Education',
  'Return to Office': 'Return to Office',

  // Super Bill
  'Super Bill': 'Super Bill',
  'Suggested Procedure': 'Suggested Procedure',
  'Unit': 'Unit',
  'Modifier': 'Modifier',
  'Additional Diagnosis': 'Additional Diagnosis',

  // Medical Rx
  'Medical Rx': 'Medical Rx',
  'Medicine Orders': 'Medicine Orders',
  'Glass Rx': 'Glass Rx',
  'E Rx Sent': 'E Rx Sent',
  'E Rx Pending': 'E Rx Pending',
  'Medication Stopped': 'Medication Stopped',

  // Procedures Section
  'Procedures': 'Procedures',
  'Operative Notes': 'Operative Notes',
  'Post Op Instructions': 'Post Op Instructions',
  'Complications': 'Complications',
  'Pre Med': 'Pre Med',
  'Intra Med': 'Intra Med',
  'Post Med': 'Post Med',
  'Observations': 'Observations',
  'Additional Information': 'Additional Information',

  // Staff
  'Staff': 'Staff',
  'Scriber': 'Scriber',
  'Consultation Notes': 'Consultation Notes',
  'Patient Notes': 'Patient Notes',

  // View Summary Popup
  'View Summary': 'View Summary',
  'ASC Download': 'ASC Download',
  'Operative Notes Tab': 'Operative Notes',
  'Discharge Summary': 'Discharge Summary',
  'Pre-op Dx': 'Pre-op Dx',
  'Post-op Dx': 'Post-op Dx',
  'Pre-Op Diagnosis': 'Pre-Op Diagnosis',
  'Post-Op Diagnosis': 'Post-Op Diagnosis',
  'Procedure (Description)': 'Procedure (Description)',
  'Anesthesia Type': 'Anesthesia Type',
  'Findings': 'Findings',
  'Surgeon Operative Notes': 'Surgeon Operative Notes',
  'Pathology': 'Pathology',
  'Code Implants': 'Code Implants',
  'Other Codes': 'Other Codes',
  'Others Implants': 'Others Implants',
  'Post Procedure Note': 'Post Procedure Note',
  'Patients Instructions': 'Patients Instructions',
  'Post OP Medications': 'Post OP Medications',
  'Medication Orders': 'Medication Orders',
  'Lab/Investigations': 'Lab/Investigations',
  'Comments': 'Comments',
  'Reviewed By': 'Reviewed By',
  'Signed by': 'Signed by',
  'Examinations/Findings': 'Examinations/Findings',
  'Post Procedures Notes': 'Post Procedures Notes',
  'Patient Instructions Discharge': 'Patient Instructions',
  'Final disposition': 'Final disposition',
  'Patient Condition on Discharge': 'Patient Condition on Discharge',
  'Co-Management': 'Co-Management',
  'Follow-Up': 'Follow-Up',
  'Signatures': 'Signatures',
  'Patient Name': 'Patient Name',
  'Nurse Name': 'Nurse Name',
  'Accompanied By': 'Accompanied By',

  // Email Popup
  'Normal Email': 'Normal Email',
  'PDF Label': 'PDF',
  'To Mail': 'To Mail',
  'Subject': 'Subject',
  'Body': 'Body',
  'Send Request': 'Send Request',

  // Reschedule Popup
  'Manage Appointment': 'Manage Appointment',
  'Please tell us why you\'d like to reschedule or cancel your appointment':
    'Please tell us why you\'d like to reschedule or cancel your appointment',
  'Enter your reason': 'Enter your reason',
  'Reason is required': 'Reason is required',
  'Please enter a valid email': 'Please enter a valid email',
  'Subject is required': 'Subject is required',

  // Export History Popover
  'Export History': 'Export History',

  // Common
  'General': 'General',
  'OD': 'OD',
  'OS': 'OS',
  'OU': 'OU',
  'Deferred': 'Deferred',
  'Refused': 'Refused',
  'Torch Used': 'Torch Used',
  'SLE Drawing': 'SLE Drawing',
  'Fundus Drawing': 'Fundus Drawing',
  'Drawing Images': 'Drawing Images',
  'Extended Ophthomology': 'Extended Ophthomology',
  'Lens Used': 'Lens Used',
  'Full And Freely Moving In All Directions': 'Full And Freely Moving In All Directions',
  'Limitation of': 'Limitation of',
  'Alphabet Pattern': 'Alphabet Pattern',
  'All Other Indications shows Negative': 'All Other Indications shows Negative',
  'Patient Indicated': 'Patient Indicated',
  'Electronically Signed By': 'Electronically Signed By',
  'Lic': 'Lic',
  'Surgeon': 'Surgeon',
  'Anesthesiologist': 'Anesthesiologist',
  'Nurse': 'Nurse',
  'Since Birth': 'Since Birth',
  'Year(s)': 'Year(s)',
  'Week(s)': 'Week(s)',
  'Month(s)': 'Month(s)',
  'Day(s)': 'Day(s)',
  'Hours': 'Hours',
  'Mild': 'Mild',
  'Moderate': 'Moderate',
  'Severe': 'Severe',
  'Provisional': 'Provisional',
  'Resolved': 'Resolved',
  'RuledOut': 'RuledOut',
  'Not Examined': 'Not Examined',
  'Entered In Error': 'Entered In Error',
  // ── Common ──
  'N/A': 'N/A',
  // ── Patient Onboarding ──
  'Change language': 'Change language',
  'Organization Logo': 'Organization Logo',
  'Step': 'Step',
  'of': 'of',
  'Upload Profile': 'Upload Profile',
  'Referral letter': 'Referral letter',
  'About you': 'About you',
  'Health': 'Health',
  'Consent': 'Consent',
  'Hi {name}!': 'Hi {name}!',
  'Save': 'Save',
  'Save & Next': 'Save & Next',
  'Save Insurance': 'Save Insurance',
  'Back Page': 'Back Page',
  'Previous Consent': 'Previous Consent',
  'Next Consent': 'Next Consent',
  'Submit': 'Submit',
  'Remove': 'Remove',
  'Capture': 'Capture',
  'Camera': 'Camera',
  'Photo Gallery': 'Photo Gallery',
  'Confirm!': 'Confirm!',
  'Take Photo': 'Take Photo',
  'Scan your photo ID': 'Scan your photo ID',
  'Line the card up inside the frame. We\'ll read the name, date of birth, ID number and address automatically.': 'Line the card up inside the frame. We\'ll read the name, date of birth, ID number and address automatically.',
  'Tap to scan ID': 'Tap to scan ID',
  'or upload photo of your ID': 'or upload photo of your ID',
  '{fields} are detected': '{fields} are detected',
  'or enter manually': 'or enter manually',
  'Enter First Name': 'Enter First Name',
  'First Name is required': 'First Name is required',
  'Please enter at least one letter in the First Name.': 'Please enter at least one letter in the First Name.',
  'Please enter First Name Minimum 2 letters.': 'Please enter First Name Minimum 2 letters.',
  'Enter Last Name': 'Enter Last Name',
  'Last Name is required': 'Last Name is required',
  'Please enter at least one letter in the Last Name.': 'Please enter at least one letter in the Last Name.',
  'Please enter Last Name Minimum 2 letters.': 'Please enter Last Name Minimum 2 letters.',
  'Only Characters Allowed are & , . ( ) / A–Z, 0–9.': 'Only Characters Allowed are & , . ( ) / A–Z, 0–9.',
  'mm-dd-yyyy': 'mm-dd-yyyy',
  'Please Enter Date Of Birth': 'Please Enter Date Of Birth',
  'Gender': 'Gender',
  'Select Gender': 'Select Gender',
  'Please Select Gender': 'Please Select Gender',
  'Address Line 1': 'Address Line 1',
  'Enter your Address': 'Enter your Address',
  'Address cannot exceed 100 characters.': 'Address cannot exceed 100 characters.',
  'Address Line 2': 'Address Line 2',
  'Enter Address Line2': 'Enter Address Line2',
  'Enter City Name': 'Enter City Name',
  'Fetching location...': 'Fetching location...',
  'Use Current Location': 'Use Current Location',
  'Enter Zipcode': 'Enter Zipcode',
  'Select Zipcode': 'Select Zipcode',
  'Enter Email': 'Enter Email',
  'Please enter a valid email address.': 'Please enter a valid email address.',
  'Enter Mobile Number': 'Enter Mobile Number',
  'Mobile number is required': 'Mobile number is required',
  'Mobile Number cannot start with 0 or 1.': 'Mobile Number cannot start with 0 or 1.',
  'Enter a valid 10-digit mobile number.': 'Enter a valid 10-digit mobile number.',
  'Send all future communication, Notices and alerts to :': 'Send all future communication, Notices and alerts to :',
  '(can select multiple)': '(can select multiple)',
  'Select': 'Select',
  'Search...': 'Search...',
  '(or)': '(or)',
  'Edit': 'Edit',
  'Close': 'Close',
  'Error': 'Error',
  'Full Name': 'Full Name',
  'Phone Number': 'Phone Number',
  'Relation to you': 'Relation to you',
  'Select Relation': 'Select Relation',
  'Self': 'Self',
  'Patient': 'Patient',
  'Guardian': 'Guardian',
  'View document': 'View document',
  'Open in new tab': 'Open in new tab',
  'Profile Picture': 'Profile Picture',
  'Please upload a clear photo of yourself': 'Please upload a clear photo of yourself',
  'Take / Upload Photo': 'Take / Upload Photo',
  'Skip for now — I\'ll add it at the front desk': 'Skip for now — I\'ll add it at the front desk',
  'Add New Insurance': 'Add New Insurance',
  'Scan your Insurance Card': 'Scan your Insurance Card',
  'Take or upload clear photos of the front and back of your insurance card.': 'Take or upload clear photos of the front and back of your insurance card.',
  'Tap to scan insurance card': 'Tap to scan insurance card',
  'Upload Front Image': 'Upload Front Image',
  'Upload Back Image': 'Upload Back Image',
  'Insurance Card Front': 'Insurance Card Front',
  'Insurance Card Back': 'Insurance Card Back',
  'Insurance Image': 'Insurance Image',
  'Skip for now - I don\'t have insurance': 'Skip for now - I don\'t have insurance',
  'Select Coverage Type': 'Select Coverage Type',
  'Please Select Coverage Type': 'Please Select Coverage Type',
  'Primary Insurance is required. Please add Primary Insurance first.': 'Primary Insurance is required. Please add Primary Insurance first.',
  'Primary and Secondary Insurance are required. Please add them first.': 'Primary and Secondary Insurance are required. Please add them first.',
  'Primary insurance is required. Add another Primary insurance first.': 'Primary insurance is required. Add another Primary insurance first.',
  'Enter Payor Name': 'Enter Payor Name',
  'Select Payor': 'Select Payor',
  'Please Select Payor': 'Please Select Payor',
  'Select Insurance Plan': 'Select Insurance Plan',
  'Select Plan': 'Select Plan',
  'Please Select Plan': 'Please Select Plan',
  'Enter Policy ID': 'Enter Policy ID',
  'Please Enter Policy ID': 'Please Enter Policy ID',
  'Policy ID cannot exceed 30 characters': 'Policy ID cannot exceed 30 characters',
  'Enter Group ID': 'Enter Group ID',
  'Please Enter Group ID': 'Please Enter Group ID',
  'Group ID cannot exceed 30 characters': 'Group ID cannot exceed 30 characters',
  'Only letters and numbers are allowed': 'Only letters and numbers are allowed',
  'Policy Holder Details': 'Policy Holder Details',
  'Insured Person': 'Insured Person',
  'Select Policy Holder': 'Select Policy Holder',
  'Please Select Insured Person': 'Please Select Insured Person',
  'Enter Insured First Name': 'Enter Insured First Name',
  'Please Enter Insured First Name': 'Please Enter Insured First Name',
  'Enter Insured Last Name': 'Enter Insured Last Name',
  'Please Enter Insured Last Name': 'Please Enter Insured Last Name',
  'SSN': 'SSN',
  'Enter SSN': 'Enter SSN',
  'Primary Insurance': 'Primary Insurance',
  'Secondary Insurance': 'Secondary Insurance',
  'Tertiary Insurance': 'Tertiary Insurance',
  'WorkersComp Insurance': 'WorkersComp Insurance',
  'Other Insurance': 'Other Insurance',
  'Patient has no insurance coverage (Self-pay)': 'Patient has no insurance coverage (Self-pay)',
  'Have a referral letter?': 'Have a referral letter?',
  'Upload your referral letter here. We\'ll use it to identify your referral provider and the reason for your visit.': 'Upload your referral letter here. We\'ll use it to identify your referral provider and the reason for your visit.',
  'Tap to upload your referral letter': 'Tap to upload your referral letter',
  'PDF, Word document, or Image': 'PDF, Word document, or Image',
  'Skip — no referral': 'Skip — no referral',
  'No Referral Letter Available': 'No Referral Letter Available',
  'This file type can\'t be previewed in the browser. Download it to view.': 'This file type can\'t be previewed in the browser. Download it to view.',
  'A little more about you': 'A little more about you',
  'Answering these questions will help us serve you better': 'Answering these questions will help us serve you better',
  'Preferred language': 'Preferred language',
  'Select Preferred Language': 'Select Preferred Language',
  'Emergency Contact': 'Emergency Contact',
  'Enter Emergency Contact Name': 'Enter Emergency Contact Name',
  'Enter Emergency Mobile Number': 'Enter Emergency Mobile Number',
  'More Info': 'More Info',
  'Select Ethnicity': 'Select Ethnicity',
  'Ethnicity is required': 'Ethnicity is required',
  'Select Sexual Orientation': 'Select Sexual Orientation',
  'Sexual Orientation is required': 'Sexual Orientation is required',
  'No More About Data Available': 'No More About Data Available',
  'Use your insights to actively improve the quality of care we deliver.': 'Use your insights to actively improve the quality of care we deliver.',
  'Health Issues': 'Health Issues',
  'I don’t have any medical conditions': 'I don’t have any medical conditions',
  'Do you have any health conditions?': 'Do you have any health conditions?',
  'Type to search conditions': 'Type to search conditions',
  'Select Health Conditions': 'Select Health Conditions',
  'No Health Issues Data Available': 'No Health Issues Data Available',
  'Medications You Are Taking': 'Medications You Are Taking',
  'Current Systemic Medications': 'Current Systemic Medications',
  'Medications you take': 'Medications you take',
  'I don’t take any medications': 'I don’t take any medications',
  'Which medications do you take regularly?': 'Which medications do you take regularly?',
  'Please type here to add meds...': 'Please type here to add meds...',
  'Select Current Medication': 'Select Current Medication',
  'No Current Medications Data Available': 'No Current Medications Data Available',
  'Daily Habits': 'Daily Habits',
  'How often do you drink alcohol?': 'How often do you drink alcohol?',
  'Do you smoke ?': 'Do you smoke ?',
  'Do you use recreational drugs or substances?': 'Do you use recreational drugs or substances?',
  'Regularly': 'Regularly',
  'Occasionally': 'Occasionally',
  'Not anymore': 'Not anymore',
  'Never': 'Never',
  'Alcohol': 'Alcohol',
  'Drugs': 'Drugs',
  'No Daily Habits Data Available': 'No Daily Habits Data Available',
  'Allergies Information': 'Allergies Information',
  'I don’t have any allergies': 'I don’t have any allergies',
  'Do you have any allergies we should know about?': 'Do you have any allergies we should know about?',
  'Select Allergy': 'Select Allergy',
  'Enter Allergies': 'Enter Allergies',
  'No Allergies Information Data Available': 'No Allergies Information Data Available',
  'Review & sign': 'Review & sign',
  'Please read and sign to complete your check-in.': 'Please read and sign to complete your check-in.',
  'Acknowledgment': 'Acknowledgment',
  'I have read and agree to the medical treatment consent from above': 'I have read and agree to the medical treatment consent from above',
  'I acknowledge that I have received the Notice of Privacy Practices and consent to the use and disclosure of my health information as described': 'I acknowledge that I have received the Notice of Privacy Practices and consent to the use and disclosure of my health information as described',
  'Digital Signature': 'Digital Signature',
  'Clear Signature': 'Clear Signature',
  'Patient Signature': 'Patient Signature',
  'Parent / Guardian': 'Parent / Guardian',
  'Guardian Signature': 'Guardian Signature',
  'Consent Status': 'Consent Status',
  'Signed': 'Signed',
  'Not Signed': 'Not Signed',
  'Signatories': 'Signatories',
  'No signatures yet.': 'No signatures yet.',
  'Review your information': 'Review your information',
  'Is everything correct? Feel free to modify any details before submitting.': 'Is everything correct? Feel free to modify any details before submitting.',
  'Personal Information': 'Personal Information',
  'Review & Confirmation': 'Review & Confirmation',
  'I hereby confirm that the information I have provided in this form, including personal details, demographic information, insurance, medical history, medications, allergies, and consents, is true, accurate, and complete to the best of my knowledge.': 'I hereby confirm that the information I have provided in this form, including personal details, demographic information, insurance, medical history, medications, allergies, and consents, is true, accurate, and complete to the best of my knowledge.',
  'Messages and OTPs will be sent to your registered mobile number.': 'Messages and OTPs will be sent to your registered mobile number.',
  'Confirm Delete': 'Confirm Delete',
  'Confirm Update': 'Confirm Update',
  'Are you sure you want to delete this insurance image?': 'Are you sure you want to delete this insurance image?',
  'Are you sure you want to delete this Profile Picture?': 'Are you sure you want to delete this Profile Picture?',
  'Are you sure you want to update the insurance?': 'Are you sure you want to update the insurance?',
  'You Did It!': 'You Did It!',
  'Thanks for filling that out — you’re officially in! We’ll take it from here.': 'Thanks for filling that out — you’re officially in! We’ll take it from here.',
  'Click Here to Login Patient Portal': 'Click Here to Login Patient Portal',

  // ── Patient Referral ──
  'Need help? Contact Support at': 'Need help? Contact Support at',
  '1. Referring Provider\'s Information': '1. Referring Provider\'s Information',
  'This ensures we can coordinate care and send follow-up reports.': 'This ensures we can coordinate care and send follow-up reports.',
  'First Name is required.': 'First Name is required.',
  'Last Name is required.': 'Last Name is required.',
  'NPI': 'NPI',
  'NPI is required.': 'NPI is required.',
  'NPI must be digits only (up to 10).': 'NPI must be digits only (up to 10).',
  'Email is required.': 'Email is required.',
  'Please enter a valid email.': 'Please enter a valid email.',
  'Organization/Practice Name': 'Organization/Practice Name',
  '2. Patient Details': '2. Patient Details',
  'Please provide the patient\'s information exactly as it appears on their health records.': 'Please provide the patient\'s information exactly as it appears on their health records.',
  'Date of Birth is required.': 'Date of Birth is required.',
  'Phone number is required.': 'Phone number is required.',
  'Gender is required.': 'Gender is required.',
  'Zip Code': 'Zip Code',
  'The patient has consented to be contacted.': 'The patient has consented to be contacted.',
  '3. Referral Destination and Reason': '3. Referral Destination and Reason',
  'Select where you\'d like to send this referral and briefly explain the reason for the visit.': 'Select where you\'d like to send this referral and briefly explain the reason for the visit.',
  'Select Location': 'Select Location',
  'Location is required.': 'Location is required.',
  'Select Provider': 'Select Provider',
  'Provider is required.': 'Provider is required.',
  'Reason': 'Reason',
  'Start typing here...': 'Start typing here...',
  'Reason is required.': 'Reason is required.',
  'Notes to Provider': 'Notes to Provider',
  'Urgency': 'Urgency',
  'Normal': 'Normal',
  'Time-sensitive': 'Time-sensitive',
  'Urgent': 'Urgent',
  'Urgency is required.': 'Urgency is required.',
  'Submitting...': 'Submitting...',
  'Submit Referral': 'Submit Referral',
  'Referral Submitted Successfully!': 'Referral Submitted Successfully!',
  'Thank you! Your referral has been sent to our team. We will contact you within 1-2 business days to schedule the consultation.': 'Thank you! Your referral has been sent to our team. We will contact you within 1-2 business days to schedule the consultation.',
  'Create another referral': 'Create another referral',

  // ── Patient Payments ──
  'Pay Your Bill Online': 'Pay Your Bill Online',
  'Settle your outstanding balance quickly and securely — from anywhere, at any time.': 'Settle your outstanding balance quickly and securely — from anywhere, at any time.',
  'How it works': 'How it works',
  'Enter your': 'Enter your',
  'name, MR number, email and phone': 'name, MR number, email and phone',
  'to verify your identity.': 'to verify your identity.',
  'Enter the': 'Enter the',
  'amount your care team confirmed': 'amount your care team confirmed',
  'during your call with us.': 'during your call with us.',
  'Complete your payment securely. A': 'Complete your payment securely. A',
  'receipt will be emailed': 'receipt will be emailed',
  'to you instantly.': 'to you instantly.',
  'Need to discuss your bill?': 'Need to discuss your bill?',
  'Our billing team is here to help.': 'Our billing team is here to help.',
  'Call us at': 'Call us at',
  'Monday–Friday, 8 am – 5 pm': 'Monday–Friday, 8 am – 5 pm',
  'Secure bill payment': 'Secure bill payment',
  'First name': 'First name',
  'Last name': 'Last name',
  'First name is required.': 'First name is required.',
  'Last name is required.': 'Last name is required.',
  'MR Number': 'MR Number',
  '(located on invoice)': '(located on invoice)',
  'A valid email address is required.': 'A valid email address is required.',
  'Phone': 'Phone',
  'Verify My Account': 'Verify My Account',
  'Online payments are not available': 'Online payments are not available',
  'This hospital does not accept online bill payments at this time. Please visit the hospital billing desk to pay your outstanding balance.': 'This hospital does not accept online bill payments at this time. Please visit the hospital billing desk to pay your outstanding balance.',
  'For questions about your bill, call': 'For questions about your bill, call',
  'Verifying...': 'Verifying...',
  'Amount confirmed with your care team': 'Amount confirmed with your care team',
  'Please enter a valid amount greater than $0.00.': 'Please enter a valid amount greater than $0.00.',
  'Billing Address': 'Billing Address',
  'Street Address': 'Street Address',
  'ZIP': 'ZIP',
  'Enter state': 'Enter state',
  'Enter your medical record number': 'Enter your medical record number',
  'Your medical record number (MR Number) is printed on your medical receipt.': 'Your medical record number (MR Number) is printed on your medical receipt.',
  'MR Number is required.': 'MR Number is required.',
  'No billing address added': 'No billing address added',
  'Save & Close': 'Save & Close',
  'Unable to update billing address. Please try again.': 'Unable to update billing address. Please try again.',
  'Please save or close the billing address before paying.': 'Please save or close the billing address before paying.',
  'Patient Outstanding Balance': 'Patient Outstanding Balance',
  'Payment allocation may take time.': 'Payment allocation may take time.',
  'Outstanding balance by organization': 'Outstanding balance by organization',
  'Total': 'Total',
  'Enter street address': 'Enter street address',
  'Enter city': 'Enter city',
  'Enter ZIP code': 'Enter ZIP code',
  'Continue to Payment': 'Continue to Payment',
  'Payment Details': 'Payment Details',
  'Payment Amount': 'Payment Amount',
  'Please enter a valid amount.': 'Please enter a valid amount.',
  'Payment Type': 'Payment Type',
  'Credit Card': 'Credit Card',
  'Debit Card': 'Debit Card',
  'Cardholder Name': 'Cardholder Name',
  'Name on Card': 'Name on Card',
  'Cardholder name is required.': 'Cardholder name is required.',
  'Loading secure payment fields...': 'Loading secure payment fields...',
  'Card Number': 'Card Number',
  'CVV': 'CVV',
  'Processing...': 'Processing...',
  'Pay': 'Pay',
  'Payment Successfully!': 'Payment Successfully!',
  'Thank you! A receipt has been sent to your email.': 'Thank you! A receipt has been sent to your email.',
  'Thank you! Your payment was successfully processed': 'Thank you! Your payment was successfully processed',
  'Amount Paid': 'Amount Paid',
  'Receipt Number': 'Receipt Number',
  'Transaction Number': 'Transaction Number',
  'Loading secure card fields...': 'Loading secure card fields...',
  'Card details cannot be entered right now': 'Card details cannot be entered right now',
  'Try again': 'Try again',
  'Minimum payment amount is $1.00.': 'Minimum payment amount is $1.00.',
  'Please enter the amount you would like to pay.': 'Please enter the amount you would like to pay.',
  'The minimum payment amount is $1.00.': 'The minimum payment amount is $1.00.',
  'Card payment is not available right now because we could not connect to the payment provider for this hospital. Please try again, or contact the billing team for help.': 'Card payment is not available right now because we could not connect to the payment provider for this hospital. Please try again, or contact the billing team for help.',
  'The secure card fields could not be loaded. This can happen with a slow or unstable internet connection, or when a browser extension (such as an ad blocker) blocks our payment provider. Please check your connection and try again.': 'The secure card fields could not be loaded. This can happen with a slow or unstable internet connection, or when a browser extension (such as an ad blocker) blocks our payment provider. Please check your connection and try again.',
  'Date & Time': 'Date & Time',
  'Generating Invoice...': 'Generating Invoice...',
  'Download Invoice': 'Download Invoice',
  'Powered by': 'Powered by',

  // ── Patient Payments - messages ──
  'Verification failed. Please check your details.': 'Verification failed. Please check your details.',
  'Verification failed. Please try again.': 'Verification failed. Please try again.',
  'No patient record found with the provided details. Please verify your information and try again.': 'No patient record found with the provided details. Please verify your information and try again.',
  'Unable to load payment fields. Please close and try again.': 'Unable to load payment fields. Please close and try again.',
  'Please enter valid card details before proceeding.': 'Please enter valid card details before proceeding.',
  'We could not securely verify your card details. Please re-enter your card information and try again.': 'We could not securely verify your card details. Please re-enter your card information and try again.',
  'Your card details could not be verified in time. Please re-enter your card information and try again.': 'Your card details could not be verified in time. Please re-enter your card information and try again.',
  'We could not reach the payment processor, so your payment was not completed. Please try again in a moment.': 'We could not reach the payment processor, so your payment was not completed. Please try again in a moment.',
  'Your card was charged, but we ran into an issue recording your payment. Please contact our billing team before attempting to pay again so you are not charged twice.': 'Your card was charged, but we ran into an issue recording your payment. Please contact our billing team before attempting to pay again so you are not charged twice.',
  'Your payment could not be completed. Please try again.': 'Your payment could not be completed. Please try again.',
  'We were unable to process your payment due to a connection issue. Your card has not been charged — please try again.': 'We were unable to process your payment due to a connection issue. Your card has not been charged — please try again.',
  'Unable to download invoice. Please try again later.': 'Unable to download invoice. Please try again later.',
  'Your card was declined. Please check your card details or try a different card.': 'Your card was declined. Please check your card details or try a different card.',
  'Your card was declined by your bank. Please contact your bank or try a different card.': 'Your card was declined by your bank. Please contact your bank or try a different card.',
  'Your card has insufficient funds. Please try a different card.': 'Your card has insufficient funds. Please try a different card.',
  'Your card is over its limit. Please try a different card.': 'Your card is over its limit. Please try a different card.',
  'Your card was declined. Please verify your card details and try again.': 'Your card was declined. Please verify your card details and try again.',
  'The card number entered does not exist. Please double-check your card number.': 'The card number entered does not exist. Please double-check your card number.',
  'This card number has been flagged as lost. Please use a different card.': 'This card number has been flagged as lost. Please use a different card.',
  'This card has expired. Please use a different card.': 'This card has expired. Please use a different card.',
  'The expiration date entered is invalid. Please check and try again.': 'The expiration date entered is invalid. Please check and try again.',
  'The CVV entered is invalid. Please check the security code on your card.': 'The CVV entered is invalid. Please check the security code on your card.',
  'This card type is not accepted. Please try a different card.': 'This card type is not accepted. Please try a different card.',
  'There was an issue verifying your card. Please try again or use a different card.': 'There was an issue verifying your card. Please try again or use a different card.',
  'This transaction exceeds the allowed amount. Please contact our billing team.': 'This transaction exceeds the allowed amount. Please contact our billing team.',
  'This transaction looks suspicious and was declined for your protection. Please contact your bank.': 'This transaction looks suspicious and was declined for your protection. Please contact your bank.',
  'The security code (CVV) entered is invalid. Please check it and try again.': 'The security code (CVV) entered is invalid. Please check it and try again.',
  'Your billing address could not be verified. Please check the address and ZIP you entered against the one on file with your bank.': 'Your billing address could not be verified. Please check the address and ZIP you entered against the one on file with your bank.',
  'This looks like a duplicate transaction. Please contact our billing team before trying again so you are not charged twice.': 'This looks like a duplicate transaction. Please contact our billing team before trying again so you are not charged twice.',
  'The card details entered appear to be invalid. Please check them and try again.': 'The card details entered appear to be invalid. Please check them and try again.',
  'Your payment could not be completed. Please check your card details and try again.': 'Your payment could not be completed. Please check your card details and try again.',

  // ── Patient Onboarding - ID scan ──
  'ID details do not match': 'ID details do not match',
  'The name or date of birth on this ID does not match the patient details for this appointment.': 'The name or date of birth on this ID does not match the patient details for this appointment.',
  'Please scan the correct ID, or enter your details manually.': 'Please scan the correct ID, or enter your details manually.',
  'Enter manually': 'Enter manually',
  'Rescan ID': 'Rescan ID',
};